module.exports = __webpack_public_path__ + "static/media/gl-logo.744a2913.png";


//////////////////
// WEBPACK FOOTER
// ./src/Components/Carousel/CarouselMedia/gl-logo.png
// module id = 158
// module chunks = 0